/*
  rein-form-submit.js — MEGA H 2026-09-28. Loaded once, globally, from layout/theme.liquid.

  One-click submit for every form Shopify's storefront captcha guards (the same selector the
  platform's inline captcha bootstrap uses: form[action*='/contact'] with form_type 'contact' or
  'customer', not data-nocaptcha="true") — the water-analysis form, the contact page, freight quote,
  shipping-help, notify-me, newsletter/popup and the quiz gate.

  Why: Shopify's bootstrap binds hCaptcha to a form only on its first `focusin`/`change`. A submit that
  arrives before the form is bound (autofill + click, a fast click while the captcha script is still
  loading) is CANCELLED with no message — the visitor has to click again. Once bound, Shopify's own
  handler runs the invisible hCaptcha and then submits natively.

  What this does (spam protection stays fully on — it only waits for it):
    * first click on an UNBOUND form: cancel that submit ourselves, disable the button and show
      "Sending…", call Shopify's public `Shopify.captcha.protect(form, cb)` to bind it, then
      `requestSubmit()` → Shopify's bound handler → invisible hCaptcha → native POST.
    * click on a BOUND form: show "Sending…" and let Shopify's handler run.
    * if the page hasn't navigated after 25 s (longer while a visible hCaptcha challenge is open),
      restore the button and show a plain retry line.
    * nothing at all when the store has no captcha (`Shopify.captcha` missing) or the form opts out
      with data-rein-oneclick="off".
*/
(function () {
  var SENDING = 'Sending…';
  var FAIL_MS = 25000, MAX_MS = 120000;
  var RETRY = "We couldn't send that just now. Please try again, or email contact@reinwaterusa.com.";

  function guarded(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    if (form.getAttribute('data-nocaptcha') === 'true' || form.dataset.reinOneclick === 'off') return false;
    if ((form.getAttribute('action') || '').indexOf('/contact') === -1) return false;
    var t = form.querySelector("input[name='form_type']");
    return !!t && (t.value === 'contact' || t.value === 'customer');
  }
  function captchaApi() {
    var s = window.Shopify;
    return s && s.captcha && typeof s.captcha.protect === 'function' ? s.captcha : null;
  }
  function bound(form) { return !!(form.dataset.hcaptchaBound || form.dataset.recaptchaBound); }
  function buttonOf(form, submitter) {
    return submitter || form.querySelector('button[type=submit], input[type=submit], button:not([type])');
  }
  function challengeOpen() {
    var frames = document.querySelectorAll('iframe[src*="hcaptcha"]');
    for (var i = 0; i < frames.length; i++) {
      var r = frames[i].getBoundingClientRect(), cs = getComputedStyle(frames[i]);
      if (r.width > 200 && r.height > 200 && cs.visibility !== 'hidden' && cs.opacity !== '0') return true;
    }
    return false;
  }

  function setSending(form, btn) {
    if (form.dataset.reinSending === '1') return;
    form.dataset.reinSending = '1';
    var old = form.querySelector('[data-rein-send-error]');
    if (old) old.remove();
    if (btn) {
      if (btn.tagName === 'INPUT') { btn.dataset.reinLabel = btn.value; btn.value = SENDING; }
      else { btn.dataset.reinLabel = btn.innerHTML; btn.textContent = SENDING; }
      btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    }
    var t0 = Date.now();
    (function watch() {
      if (form.dataset.reinSending !== '1') return;
      var waited = Date.now() - t0;
      if (waited < FAIL_MS || (challengeOpen() && waited < MAX_MS)) { setTimeout(watch, 1000); return; }
      fail(form, btn);
    })();
  }

  function fail(form, btn) {
    delete form.dataset.reinSending;
    if (btn) {
      if (btn.tagName === 'INPUT') btn.value = btn.dataset.reinLabel || btn.value;
      else if (btn.dataset.reinLabel != null) btn.innerHTML = btn.dataset.reinLabel;
      btn.disabled = false; btn.removeAttribute('aria-busy');
    }
    var p = document.createElement('p');
    p.setAttribute('data-rein-send-error', '');
    p.setAttribute('role', 'alert');
    p.className = 'rein-send-error';
    p.style.cssText = 'margin:10px 0 0;font-size:1.4rem;line-height:1.5;';
    p.textContent = RETRY;
    (btn && btn.parentNode ? btn.parentNode : form).appendChild(p);
  }

  // Capture phase on document: runs before the form's own handlers and before Shopify's bubbling
  // bootstrap listener, so an unbound submit is taken over before the platform silently cancels it.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!guarded(form)) return;
    var api = captchaApi();
    if (!api) return;                                   // no captcha on this store: native submit
    var btn = buttonOf(form, e.submitter);
    if (form.dataset.reinSending === '1' && !bound(form)) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    if (bound(form)) { setSending(form, btn); return; } // Shopify's bound handler takes it from here
    e.preventDefault();
    e.stopImmediatePropagation();
    setSending(form, btn);
    try {
      api.protect(form, function () {
        if (form.dataset.reinSending !== '1') return;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      });
    } catch (err) {
      fail(form, btn);
    }
  }, true);
})();
